/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-LIcense-Identifier: Apache-2.0
 */
import { css } from 'lit';
export const styles = css `.mdc-text-field{height:100%}.mdc-text-field__input{resize:none}`;
//# sourceMappingURL=mwc-textarea.css.js.map